
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const ResponsiveLandingPortFolio = (props) => {
  const { t , i18n} = useTranslation()

  const [OpenMedia, setOpenMedia] = useState(false);
  const [openEducation, setOpenEducation] = useState(false);
  const [openWeb, setOpenWeb] = useState(false);
  const [openDigital, setOpenDigital] = useState(false);
  const [openEvent, setOpenEvent] = useState(false);

  return (
    <div className="ResponsiveWorks">
      <button
        onClick={() => {
          props.setFilter(prev => !prev);
          props.setShowData("all");
        }}
        className="link1"
      >
        {t("All")}
      </button>

      <button onClick={() => setOpenMedia(prev => !prev)} className="link1">
        {t("Media Production")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: OpenMedia ? "122px" : "0px" }}
      >
        <button
          onClick={() => {
            setOpenMedia(false);
            props.setFilter(prev => !prev);
            props.setShowData("renting");
          }}
          className="link"
        >
          {t("Renting Company Studios")}
        </button>
        <button
          onClick={() => {
            setOpenMedia(false);
            props.setFilter(prev => !prev);
            props.setShowData("postProduction");
          }}
          className="link"
        >
          {t("Post Production")}
        </button>
        <button
          onClick={() => {
            setOpenMedia(false);
            props.setFilter(prev => !prev);
            props.setShowData("photography");
          }}
          className="link"
        >
          {t("Photography")}
        </button>
        <button
          onClick={() => {
            setOpenMedia(false);
            props.setFilter(prev => !prev);
            props.setShowData("videography");
          }}
          className="link"
        >
          {t("Videography")}
        </button>
      </div>

      <button onClick={() => setOpenEducation(prev => !prev)} className="link1">
        {t("Education Services")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openEducation ? "172px" : "0px" }}
      >
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("platforms");
          }}
          className="link"
        >
          {t("Training Platforms")}
        </button>
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("bags");
          }}
          className="link"
        >
          {t("Training Bags")}
        </button>
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("electronic");
          }}
          className="link"
        >
          {t("Electronic Marketing")}
        </button>
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("trainingContent");
          }}
          className="link"
        >
           {t("Training Content")}
        </button>
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("Pm");
          }}
          className="link"
        >
          {t("Project Management")}
        </button>
        <button
          onClick={() => {
            props.setFilter(prev => !prev);
            props.setShowData("virtial");
          }}
          className="link"
        >
          {t("Virtual Projects")}
        </button>
      </div>

      <button onClick={() => setOpenWeb(prev => !prev)} className="link1">
        {t("Web Solution")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openWeb ? "50px" : "0px" }}
      >
        <button
          onClick={() => {
            setOpenWeb(false);
            props.setFilter(prev => !prev);
            props.setShowData("webDesign");
          }}
          className="link"
        >
          {t("Web Design")}
        </button>
        <button
          onClick={() => {
            setOpenWeb(false);
            props.setFilter(prev => !prev);
            props.setShowData("development");
          }}
          className="link"
        >
          {t("Web Development")}
        </button>
      </div>

      <button onClick={() => setOpenDigital(prev => !prev)} className="link1">
        {t("Digital Marketing")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openDigital ? "120px" : "0px" }}
      >
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("socialMedia");
          }}
          className="link"
        >
          {t("Social Media")}
        </button>
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("mediaBuying");
          }}
          className="link"
        >
          {t("Media Buying")}
        </button>
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("influencer");
          }}
          className="link"
        >
        {t("Influencer Marketing")}
        </button>
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("seo");
          }}
          className="link"
        >
          {t("SEO Services")}
        </button>
      </div>
      <button onClick={() => setOpenEvent(prev => !prev)} className="link1">
        {t("Event Management")}
      </button>
      <div
        className="services-list m-0 flex flex-col justify-start items-start gap-[6px] overflow-hidden transition-all duration-500 ease-in-out"
        style={{ height: openEvent ? "50px" : "0px" }}
      >
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("Implementation");
          }}
          className="link"
        >
     {t("Implementation of conference-related work")}
        </button>
        <button
          onClick={() => {
            setOpenDigital(false);
            props.setFilter(prev => !prev);
            props.setShowData("Conference");
          }}
          className="link"
        >
          {t("Conference management and organization")}
        </button>
    
    
      </div>
    </div>
  );
};

export default ResponsiveLandingPortFolio;

